window.EOMChatbotConfig = {
  storeName: "EarthOnMall",
  supportEmail: "contact@earthonmall.com",
  timezone: "America/Los_Angeles",
  supportHours: {
    days: [1, 2, 3, 4, 5, 6],
    startHour: 9,
    endHour: 17
  },
  responsePromise:
    "We usually respond within 4 hours during regular business hours when live help is not available, and by the next business day otherwise.",
  liveMode: "shopify_only",
  tickets: {
    mode: "shopify_contact_form",
    contactPage: "/pages/contact"
  },
  analytics: {
    useDataLayer: true,
    useGtag: true,
    useShopifyAnalytics: true,
    namespace: "eom_chatbot"
  },
  behavior: {
    minimumBotDelayMs: 650,
    typingLabel: "EarthOnMall is typing"
  },
  claims: {
    sameDayDispatch: "Same-day dispatch",
    freeDelivery: "Free delivery",
    returns: "60-day returns",
    bulkSavings: "Bulk savings start at 2 eligible boxes"
  },
  safety: {
    minors:
      "EarthOnMall nicotine replacement products are not sold to minors. These products are intended for adults and may be subject to age restrictions based on location and product type.",
    medical:
      "I can help with EarthOnMall shopping and product-label information, but I cannot give medical advice. Please read and follow the exact product label, and ask a healthcare professional if you are unsure."
  },
  routes: {
    home: "/",
    shop: "/collections/all",
    gum: "/collections/nicotine-gum",
    patches: "/collections/nicotine-patches",
    lozenges: "/collections/nicotine-lozenges",
    habitrol: "/collections/habitrol",
    nicotrol: "/collections/nicotrol",
    quitine: "/collections/quitine",
    rugby: "/collections/rugby",
    startingPoint: "/pages/find-my-starting-point",
    compareTypes: "/pages/patch-vs-gum-vs-lozenge",
    strengthGuide: "/pages/how-to-choose-your-strength",
    productSafety: "/pages/product-safety",
    subscribe: "/pages/subscribe-and-save",
    faq: "/pages/faq-center",
    tracking: "/pages/track-my-order",
    shippingReturns: "/pages/shipping-returns",
    contact: "/pages/contact",
    privacy: "/policies/privacy-policy",
    terms: "/policies/terms-of-service"
  },
  quickActions: [
    { label: "Find a product", action: "flow:product_finder" },
    { label: "Compare options", action: "intent:compare_types" },
    { label: "Choose strength", action: "intent:strength" },
    { label: "Track order", action: "intent:track_order" },
    { label: "Shipping/returns", action: "intent:shipping_returns" },
    { label: "Subscribe & Save", action: "intent:subscribe" },
    { label: "Product safety", action: "intent:safety" },
    { label: "Contact support", action: "flow:ticket" }
  ]
};
